import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const mainSkillCategoriesAPI = createApi({
    reducerPath: 'mainSkillCategoriesAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //**  AddEdit API */
        addEditMainSkill: builder.mutation({
            query: (Details) => ({
                url: '/Skill/AddEditMainSkill',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  List API */
        getMainSkill: builder.mutation({
            query: (userQuery) => ({
                url: '/Skill/GetMainSkill',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  GetByID API */
        getMainSkillByMainSkillId: builder.query({
            query: (mainSkillId) => ({
                url: encryptQueryString(`/Skill/GetMainSkillByMainSkillId/?mainSkillId=${Number(mainSkillId)}`),
                method: 'GET',
            }),
 
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Delete API */
        deleteMainSkill: builder.mutation({
            query: (mainSkillId) => ({
                url: `/Skill/DeleteMainSkill/?mainSkillId=${mainSkillId}`,
                method: 'DELETE',
                body: transformRequest(mainSkillId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
})

export const {  useAddEditMainSkillMutation,useGetMainSkillMutation,useLazyGetMainSkillByMainSkillIdQuery,useDeleteMainSkillMutation,} = mainSkillCategoriesAPI;

export default mainSkillCategoriesAPI;